import OadpImg from './oadp-img';
export default OadpImg;
